import { UserOutlined } from '@ant-design/icons';
import { Col, Row, Space } from 'antd';
import get from 'lodash/get';
import Avatar from 'antd/lib/avatar/avatar';

// import remove_red from '../../assets/icons/remove_red.svg';

export const assistantsColumn = ({ toggleRemove, toggleEditAssistant }) => [
  {
    title: 'Assistant Name',
    dataIndex: 'name',
    key: 'name',
    render: (name, record) => (
      <Row>
        <Space>
          <Col>
            {get(record, 'image') ? (
              <Avatar size={48} src={record?.image?.url} />
            ) : (
              <Avatar size={48} icon={<UserOutlined />} />
            )}
          </Col>
          <Col>
            <div className="medium-bold">{name}</div>
          </Col>
        </Space>
      </Row>
    ),
  },

  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {},
  {
    title: 'Contact Number',
    dataIndex: 'contact_number',
    key: 'contact_number',
    render: (contact_number, record) =>
      `+${get(record, 'contact_code')} ${contact_number}`,
  },
];
